export default {"src":"/_next/static/media/1.966c3cf0.svg","height":400,"width":1200};